import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import useAuth from './useAuth';
import LoadingBlock from '../Common/LoadingBlock';
import ErrorHandler from '../Common/ErrorHandler';
export default function AuthWrapper({ children }) {
    const { auth, loading } = useAuth();
    return loading ? (_jsx(LoadingBlock, {})) : auth ? (_jsx(Fragment, { children: children })) : (_jsx(ErrorHandler, { status: 401 }));
}
